// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BookTwoToneSvg from "@fishx/icons-svg/es/asn/BookTwoTone";
import FishxIcon from '../components/FishxIcon';

var BookTwoTone = function BookTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BookTwoToneSvg
  }));
};

BookTwoTone.displayName = 'BookTwoTone';
export default React.forwardRef(BookTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BookTwoTone.js
// module id = 2090
// module chunks = 0